import { api } from '../api';
import type { UnitFamilyGroup } from '@/types/unit';

/**
 * The unit tables live in the API's costing code rather than in a table, so this
 * is a plain read with nothing tenant-specific in it — safe to cache for the
 * whole session.
 */
export const unitApi = {
  getAll: () => api.get<UnitFamilyGroup[]>('/units'),
};
